export default {
  GET_CONVERSATION_DETAILS: 'GET_CONVERSATION_DETAILS',
  GET_CONVERSATION_DETAILS_SUCCESS: 'GET_CONVERSATION_DETAILS_SUCCESS',
  GET_CONVERSATION_DETAILS_ERROR: 'GET_CONVERSATION_DETAILS_ERROR',
  SET_AUDIO_COMPOSITION_REQUESTED: 'SET_AUDIO_COMPOSITION_REQUESTED',
  SET_AUDIO_COMPOSITION_REQUESTED_ERROR: 'SET_AUDIO_COMPOSITION_REQUESTED_ERROR',
}
